(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu-panel]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menuButton.querySelector('.visually-hidden').textContent = open ? 'Menü öffnen' : 'Menü schließen';
      menu.classList.toggle('is-open', !open);
    });
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.querySelector('.visually-hidden').textContent = 'Menü öffnen';
        menu.classList.remove('is-open');
      }
    });
  }

  document.querySelectorAll('[data-quantity-step]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[type="number"]');
      const current = Number.parseInt(input.value || '1', 10);
      input.value = String(Math.max(1, current + Number(button.dataset.quantityStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const update = () => {
      const option = select.selectedOptions?.[0] || select;
      const price = option.dataset.price;
      const available = option.dataset.available !== 'false';
      const scope = select.closest('[data-product]');
      if (!scope) return;
      const priceTarget = scope.querySelector('[data-product-price]');
      const addButton = scope.querySelector('[data-add-button]');
      if (priceTarget && price) priceTarget.textContent = price;
      if (addButton) {
        addButton.disabled = !available;
        const label = available ? 'In den Warenkorb' : 'Derzeit ausverkauft';
        const arrow = addButton.querySelector('svg');
        addButton.firstChild.textContent = label;
        if (arrow) addButton.appendChild(arrow);
      }
    };
    select.addEventListener('change', update);
  });
})();
